export enum PrescriptionVariant {
  REGULAR = 'prescription',
  ONLINE = 'ePrescription',
}

// TODO: replce with export from ia-utils
export type MimeType = 'application/pdf' | 'image/png' | 'image/jpeg'
